<template>
  <div v-on-clickaway="reset">
    <ul class="d-flex align-center">
      <li
        v-for="(activities, activitiesIndex) of filteredActivity"
        :key="activitiesIndex"
        class="mr-3"
        style="list-style: none"
        :class="{ opacity: isActive !== activities.state && isActive !== null }"
        @click="getState(activities)"
      >
        <div
          class="d-flex flex-row align-center "
          style="width: 100%"
          v-if="
            activities.state === 'created' ||
              activities.state === 'scheduled' ||
              activities.state === 'company_assign'
          "
        >
          <task-state-icon :state="activities.state" />
          <span class="font  ">{{
            numberOfActivityStates(activities.state)
          }}</span>
        </div>

        <div
          class="d-flex flex-row align-center"
          v-if="activities.state === 'in_progress'"
        >
          <task-state-icon :state="activities.state" />
          <span class="font">{{
            numberOfActivityStates(activities.state)
          }}</span>
        </div>
        <div
          class="d-flex flex-row align-center"
          v-if="activities.state === 'blocked'"
        >
          <task-state-icon :state="activities.state" />
          <span class="font">{{
            numberOfActivityStates(activities.state)
          }}</span>
        </div>
        <div
          class="d-flex flex-row align-center"
          v-if="
            activities.state === 'completed' || activities.state === 'approved'
          "
        >
          <task-state-icon :state="activities.state" />
          <span class="font">{{
            numberOfActivityStates(activities.state)
          }}</span>
        </div>
        <div
          class="d-flex flex-row align-center"
          v-if="activities.state === 'pending_approval'"
        >
          <task-state-icon :state="activities.state" />
          <span class="font">{{
            numberOfActivityStates(activities.state)
          }}</span>
        </div>
        <div
          class="d-flex flex-row align-center"
          v-if="activities.state === 'reopened'"
        >
          <task-state-icon :state="activities.state" />
          <span class="font">{{
            numberOfActivityStates(activities.state)
          }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import TaskStateIcon from "../_Atoms/TaskStateIcon.vue";
import { mixin as clickaway } from "vue-clickaway";
export default {
  name: "activityTasksState",

  components: { TaskStateIcon },

  mixins: [clickaway],

  props: {
    activitiesOrTasks: {
      type: Array
    }
  },
  data() {
    return {
      isActive: null
    };
  },
  computed: {
    /**
     * @returns - Activities or tasks unique object array with same state
     */
    filteredActivity() {
      let arr = this.activitiesOrTasks.filter(
        (value, index, self) =>
          index === self.findIndex(t => t.state === value.state)
      );
      return arr;
    }
  },
  methods: {
    /**
     * sets the filter state
     */
    getState(item) {
      this.isActive = item.state;
      this.$emit("isActive", this.isActive, item.object_type);
    },
    /**
     * resets the filter state
     */
    reset() {
      this.isActive = null;
    },
    /**
     * @returns - Number of states that exist with same name and the state itself
     */
    numberOfActivityStates(state) {
      let states = this.activitiesOrTasks.filter(item => item.state === state)
        .length;
      return `${this.capitalizeFirstLetter(state)}` + " " + ` (${states})`;
    },
    /**
     * @returns - string with first letter capitalized
     */
    capitalizeFirstLetter(str) {
      let string = str.replace("_", " ");
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>
<style scoped>
.opacity {
  opacity: 0.4;
}
.font {
  font-family: roboto;
  font-size: 13px;
  letter-spacing: 0.1px;
  color: #666666;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/_Organisms/ActivityTasksState.vue